/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_iupac_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IUPAC to Regex Converter — Toolverse`)
};

const es_iupac_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversor de IUPAC a Regex — Toolverse`)
};

const de_iupac_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IUPAC-zu-Regex-Konverter — Toolverse`)
};

const nl_iupac_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IUPAC-naar-regexconverter — Toolverse`)
};

const fr_iupac_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convertisseur IUPAC vers Regex — Toolverse`)
};

const it_iupac_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convertitore da IUPAC a espressione regolare — Toolverse`)
};

const pt_br2_iupac_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversor de IUPAC para Regex — Toolverse`)
};

const pt_iupac_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversor de IUPAC para Regex — Toolverse`)
};

const ja_iupac_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IUPAC→正規表現変換ツール — Toolverse`)
};

const zh_iupac_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IUPAC 转正则表达式转换器 — Toolverse`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const iupac_meta_title = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.iupac_meta_title(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("iupac_meta_title", locale)
	if (locale === "en") return en_iupac_meta_title(inputs)
	if (locale === "es") return es_iupac_meta_title(inputs)
	if (locale === "de") return de_iupac_meta_title(inputs)
	if (locale === "nl") return nl_iupac_meta_title(inputs)
	if (locale === "fr") return fr_iupac_meta_title(inputs)
	if (locale === "it") return it_iupac_meta_title(inputs)
	if (locale === "pt-BR") return pt_br2_iupac_meta_title(inputs)
	if (locale === "pt") return pt_iupac_meta_title(inputs)
	if (locale === "ja") return ja_iupac_meta_title(inputs)
	return zh_iupac_meta_title(inputs)
};